module.exports = __webpack_public_path__ + "static/img/img-cp4.8283319.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp4.png
// module id = p1No
// module chunks = 0